import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { catalogFilterMatchTags, CatalogFilterProduct } from './catalog-filters';
import { ShopCatalogFiltersService } from './shop-catalog-filters.service';

@Component({
  selector: 'app-catalog-filter-match-tags',
  imports: [TranslatePipe],
  host: { class: 'contents' },
  template: `
    @for (tag of tags(); track tag.id) {
      <span
        class="inline-flex h-5 items-center justify-center gap-1 rounded bg-neutral-100 px-1.5 font-base text-xs font-normal leading-none text-neutral-800"
      >
        @if (tag.warning) {
          <i
            class="icon icon-warning-square text-sm leading-none text-error-600"
            aria-hidden="true"
          ></i>
        }
        <span class="leading-none">{{
          tag.kind === 'allergen' ? ('allergens.' + tag.name | translate) : tag.name
        }}</span>
      </span>
    }
  `,
})
export class CatalogFilterMatchTagsComponent {
  private readonly catalogFilters = inject(ShopCatalogFiltersService);

  readonly product = input.required<CatalogFilterProduct>();

  protected readonly tags = computed(() =>
    catalogFilterMatchTags(this.product(), this.catalogFilters.applied()),
  );
}
